import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { twMerge } from 'tailwind-merge';
import { Container } from './Container';
import { faqs } from '../data/landing';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-labelledby="faq-title" className="bg-cream py-16 sm:py-20 lg:py-24" data-id="element-144" data-mp="1cft11lf9ehsg">
      <Container data-id="element-145" data-mp="2a17a6qi2171z">
        <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16" data-id="element-146" data-mp="2a1qidfhwkh2t">
          <div data-id="element-147" data-mp="25472kb5k3w8r">
            <h2 id="faq-title" className="font-heading text-[1.95rem] font-black leading-[1.1] tracking-[-0.01em] text-navy sm:text-4xl lg:text-[2.85rem]" data-id="element-148" data-mp="253oy4r8qqbpr">
              Lo que más nos preguntan
            </h2>
            <p className="mt-4 text-base leading-relaxed text-navy-soft sm:text-lg" data-id="element-149" data-mp="oonqnls38hpj">
              ¿Te quedó alguna duda?{' '}
              <a href="mailto:soporte.viandasexpress15@gmail.com" className="font-semibold text-teal-dark underline decoration-teal/40 underline-offset-4 hover:decoration-teal-dark" data-id="element-150" data-mp="joridaccy446">
                Escribinos a soporte
              </a>
              .
            </p>
          </div>

          <ul className="space-y-3" data-id="element-151" data-mp="1aqc2njiyivan">
            {faqs.map((f, i) => {
            const isOpen = open === i;
            return <li key={f.q} className="rounded-[20px] border border-teal-soft bg-white px-5 sm:px-6" data-id="element-152" data-mp="1fmsqecm8v7n7" data-mpi={i}>
                  <h3 data-id="element-153" data-mp="11vxq3opt9yv8">
                    <button type="button" aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} id={`faq-button-${i}`} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 py-5 text-left font-heading text-base font-extrabold text-navy sm:text-lg" data-id="element-154" data-mp="16nywwv47mxdv">
                      {f.q}
                      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-pink-light" data-id="element-155" data-mp="n22kqsov6ros">
                        <PlusIcon aria-hidden="true" strokeWidth={2.5} className={twMerge('h-4 w-4 text-pink transition-transform duration-200 ease-out', isOpen && 'rotate-45')} data-id="element-156" data-mp="2kvwyag0evn3v" />
                      </span>
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-157" data-mp="38kzf5ln81bxb">
                    {isOpen && <motion.div id={`faq-panel-${i}`} role="region" aria-labelledby={`faq-button-${i}`} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-158" data-mp="33npsgdr7ved6">
                        <p className="pb-5 pr-8 text-base leading-relaxed text-navy-soft" data-id="element-159" data-mp="3uvrcbyutw9ga">{f.a}</p>
                      </motion.div>}
                  </AnimatePresence>
                </li>;
          })}
          </ul>
        </div>
      </Container>
    </section>;
}